/* eslint-disable @typescript-eslint/naming-convention */
import useConfigureActivePlans from 'Hooks/useConfigureActivePlans/useConfigureActivePlans'
import React, { ComponentType, FC } from 'react'
import { useAppState } from 'Context/AppContext/AppContext'
import { Redirect } from 'react-router'

export const defaultFallback = (): JSX.Element => <></>

// eslint-disable-next-line @typescript-eslint/ban-types
const WithPermission = <P extends object>(
  ComponentToValidate: ComponentType<P>,
  requiredPermissions: string[],
  redirectToRoot?: boolean,
  onFallback: () => JSX.Element = defaultFallback
): FC<P> => {
  const WithPermissionComponent = (componentProps: P): JSX.Element => {
    const { configIsLoading } = useConfigureActivePlans()
    const appState = useAppState()

    const {
      userConfig: { permissions: userPermissions },
    } = appState

    const renderComponent = requiredPermissions.every((permission) =>
      userPermissions?.includes(permission)
    )

    if (!renderComponent && redirectToRoot && !configIsLoading) {
      return <Redirect to='/' />
    }

    return renderComponent ? (
      <ComponentToValidate {...(componentProps as P)} />
    ) : (
      onFallback()
    )
  }

  return WithPermissionComponent
}
export default WithPermission
